export default {"src":"https://images-cdn-staging.curipod.com/d-49646873/_next/static/media/rocket.9360f2a3.svg","height":199,"width":200};